<div [ngStyle]="getContentStyle()" class="template-list">
  <ng-container *ngIf="listData?.length; else noRecord" class="h-100">
    <ul class="pointer-events-none" [ngStyle]="ulCssStyle">
      <li
        *ngFor="let listItem of listData"
        [innerHTML]="renderTemplateItem(listItem) | safeHtml"
        (click)="onClickItem(listItem)"
        [ngStyle]="liCssStyle"
      ></li>
    </ul>
  </ng-container>
</div>
<ng-template #noRecord>
  <div [innerHTML]="noRecordsTemplate | safeHtml"></div>
</ng-template>
